import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, Subject, startWith, debounceTime, distinctUntilChanged, switchMap, of, map } from 'rxjs';
import { SnackBarService } from 'src/app/services/snack-bar-service.service';
import { IFiltroMotoristaModel, IMotoristaModel } from '../model/motorista.model';
import { MotoristaService } from '../motorista.service';
import { PesquisaMotoristaComponent } from '../pesquisa-motorista/pesquisa-motorista.component';

@Component({
  selector: 'app-filtro-motorista',
  templateUrl: './filtro-motorista.component.html',
  styleUrls: ['./filtro-motorista.component.scss']
})
export class FiltroMotoristaComponent implements OnInit, OnDestroy {

  @Output() onMotoristaSelected = new EventEmitter<IMotoristaModel | null>();

  filtro !: IFiltroMotoristaModel;

  filteredOptions!: Observable<any>;

  search$ = new Subject<string>();

  constructor(private motoristaService: MotoristaService, public dialog: MatDialog, private snackBar: SnackBarService) {

    this.filtro = { guid: this.motoristaService.usuario.retorno.guid, coluna: '1', operador: 1 };
  }

  ngOnInit(): void {
    if (this.motoristaService.usuario == null) {
    this.snackBar.flashMessage('Sessão expirada. Favor logar novamente no sistema.', ['snackbar-error'], 'Fechar', 0);
  }
  else {

    this.filteredOptions = this.search$
      .pipe(
        startWith(''),
        debounceTime(400),
        distinctUntilChanged(),
        switchMap(val => {
          return this.filter(val || '')
        })
      );

    if (sessionStorage.getItem('filtroMotorista')) {
      var localFiltro = JSON.parse(sessionStorage.getItem('filtroMotorista') ?? '{}');
      if (localFiltro.guid === this.filtro.guid) {
        this.filtro = localFiltro;
      } else {
        sessionStorage.removeItem('filtroMotorista');
      }
    }
  }
  }

  filter(val: string): Observable<any[]> {

    if (!val.length || val.length < 2) {
      return of([]);
    }
    // call the service which makes the http-request
    var filtro = { conteudo: val, guid: this.motoristaService.usuario.retorno.guid, frota: { codigo: this.motoristaService.usuario.retorno.codigoEntidade } };
    
    return this.motoristaService.searchMotorista(filtro).pipe(map(response => { return response.retorno }));
  }

  listMotorista(val: string): Observable<any[]> {

    if (!val.length || val.length < 2) {
      return of([]);
    }
    // call the service which makes the http-request
    var filtro = { conteudo: val, guid: this.motoristaService.usuario.retorno.guid, frota: { codigo: this.motoristaService.usuario.retorno.codigoEntidade }};
    return this.motoristaService.searchMotorista(filtro).pipe(map(response => { return response.retorno }));
  }

  displayFn(motorista: IMotoristaModel): string {
    return motorista && motorista.busca ? motorista.busca : '';
  }

  onSubmit(): void {
    const dialogRef = this.dialog.open(PesquisaMotoristaComponent, { width: '800px', height: '700px', data: { dataKey: structuredClone(this.filtro) } }).afterClosed()
      .subscribe(response => {
        if (response && response.data) {
          this.filtro.motorista = response.data;
          this.onMotoristaSelected.emit(this.filtro.motorista);
        }
      });;
  }

  getPosts(selectMotorista: IMotoristaModel) {
    this.filtro.motorista = selectMotorista;
    this.filtro.parametro = '';
    this.onMotoristaSelected.emit(this.filtro.motorista);
  }

  limpaFiltro() {
    this.filtro.motorista = undefined;
    this.onMotoristaSelected.emit(this.filtro.motorista);
    sessionStorage.removeItem('filtroMotorista');
    this.filtro = { guid: this.motoristaService.usuario.retorno.guid, coluna: '1', operador: 1 };
  }


  ngOnDestroy() {
    sessionStorage.setItem('filtroMotorista', JSON.stringify(this.filtro));
  }

}